export default class ModelNotReadyException extends Error {
    constructor() {
        super("Trying to access model before it has been fully initialized!");
    }
}
